import type { ProductCatalogData, SaleRequestTemplateData } from '@/api/kubik/monolith'

export const isInputsProduct = (product: ProductCatalogData | SaleRequestTemplateData): product is ProductCatalogData => 'sku' in product
